import {getMedicationProfileFormDefaultValues} from '@/modules/drug-catalog/medication-profiles/functions'
import {StabilityRuleFormSchema} from '@/modules/drug-catalog/stability-rules/schemas'
import {SubmitEvent} from 'react'

interface MedicationProfileFormFieldsProps {
  onAddStabilityRule: VoidFunction
  onEditStabilityRule: (rule: StabilityRuleFormSchema, index: number) => void
  onDeleteStabilityRule: (index: number) => void
  onCancel?: VoidFunction
}

interface MedicationProfileFormDialogProps extends MedicationProfileFormFieldsProps {
  onSubmit: (event: SubmitEvent<HTMLFormElement>) => void
  title: string
  description: string
}

export const MedicationProfileFormFieldsOptions = {
  defaultValues: getMedicationProfileFormDefaultValues(undefined),
  props: {
    onAddStabilityRule: () => {},
    onEditStabilityRule: (_rule: StabilityRuleFormSchema, _index: number) => {},
    onDeleteStabilityRule: (_index: number) => {},
  } as MedicationProfileFormFieldsProps,
}

export const MedicationProfileFormDialogOptions = {
  defaultValues: getMedicationProfileFormDefaultValues(undefined),
  props: {
    ...MedicationProfileFormFieldsOptions.props,
    onSubmit: (_event: SubmitEvent<HTMLFormElement>) => {},
    title: '',
    description: '',
  } as MedicationProfileFormDialogProps,
}
